import { render } from "./Dessert.vue?vue&type=template&id=5d300041"
import script from "./Dessert.vue?vue&type=script&lang=js"
export * from "./Dessert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__